<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { Keyboard } from "@capacitor/keyboard";

import SocketManager from "@/Components/Extend/TcSocketManager.vue";

import useAppStore from "@/Modules/App/Store";

import { log } from "@/Utils/Debug";
import { isApp } from "@/Utils/Ionic";

const appStore = useAppStore();

onMounted(async () => {
  if (isApp()) {
    Keyboard.addListener("keyboardDidShow", (info) => {
      log("keyboard will show with height:", info.keyboardHeight);
      appStore.updateKeyboardStatus(true);
    });

    Keyboard.addListener("keyboardDidHide", () => {
      log("keyboard will show with height:");
      appStore.updateKeyboardStatus(false);
    });
  } else {
    appStore.updateKeyboardStatus(false);
  }
});

onUnmounted(() => {
  if (isApp()) {
    Keyboard.removeAllListeners();
  }
});
</script>

<template>
  <SocketManager>
    <slot />
  </SocketManager>
</template>
